import { t } from "i18next";
export const FIELD_REQUIRED_MESSAGE = t("require");
export const EMAIL_VALIDATION_ERRROR =
  "Dirección de correo electrónico no válida";
export const DATE_VALIDATION_ERRROR = "La fecha no es una fecha válida";
export const DATE_MAYOR_VALIDATION_ERROR = "La fecha no puede ser mayor a hoy";
